module.exports = __webpack_public_path__ + "static/media/boloAuto-form.b1ba5eca.svg";